import React, { Component } from "react";
import { Link, NavLink } from "react-router-dom";

const Navbar = () => {
  return (
    <>
    <div className="back-color mt-5 ">
     <nav className="navbar navbar-expand-lg navbar-light  container">
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon" />
        </button>
        <div className="collapse navbar-collapse" id="navbarNavDropdown">
          <ul className="navbar-nav  margin-right">
        
          <li className="nav-item active">
              <Link className="nav-link text-white  font-weight-bold font ml-0 ml-md-5
" to="/">Home </Link>
            </li>
   
            <li className="nav-item active">
              <Link className="nav-link text-white  font-weight-bold font ml-0 ml-md-5
" to="/about-us">About Me </Link>
            </li>
           
            <li className="nav-item dropdown">
            <li className="nav-item active">
              <Link className="nav-link text-white font-weight-bold font ml-0 ml-md-5
" to="/contact-us">Contact Me</Link>
            </li>
            
            </li>

          </ul>
        </div>

      </nav>

    </div>
    </>
  );
};

export default Navbar;